import React, { useRef, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { Icon } from '../core/icon';
import { renderIcon } from './renderIcon';
import { useDispatch, useSelector } from 'react-redux';
import Badge from './Badge';
import { useServices } from './ServiceProvider';
const CreateNewResourceButton = () => {
    const { ProjectService, WorkspaceService } = useServices();
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const resourceTypes = useSelector(ProjectService.selectors.getResourceTypes);
    const dispatch = useDispatch();
    return (React.createElement("span", null,
        React.createElement(IconButton, { ref: buttonRef, onClick: () => setOpen(!open) }, renderIcon(Icon.NEW_RESOURCE)),
        React.createElement(Menu, { anchorEl: buttonRef.current, onClose: () => setOpen(false), open: open }, Object.entries(resourceTypes).map(([resourceTypeId, resourceType]) => (React.createElement(MenuItem, { key: resourceTypeId, onClick: () => {
                dispatch(WorkspaceService.createNew(resourceType));
                setOpen(false);
            } },
            React.createElement(Badge, { icon: resourceType.icon, iconSize: 'small', label: resourceType.name })))))));
};
export default CreateNewResourceButton;
//# sourceMappingURL=CreateNewResourceButton.js.map